var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8083_35794)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#F2F9FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6455 23C13.7636 23 12.2909 21.6122 12.2909 19.898V13.0408C12.2909 11.898 13.3545 10.9184 14.5818 10.9184C15.8091 10.9184 16.8727 11.898 16.8727 13.0408V16.9592C16.8727 17.2857 16.5455 17.6122 16.2182 17.6122C15.8909 17.6122 15.5636 17.2857 15.5636 16.9592V13.0408C15.5636 12.551 15.1545 12.2245 14.5818 12.2245C14.0091 12.2245 13.6 12.551 13.6 13.0408V19.898C13.6 20.8776 14.5 21.6939 15.6455 21.6939C16.2182 21.6939 16.7091 21.5306 17.1182 21.1224C17.5273 20.7959 17.6909 20.3061 17.6909 19.898V11.0816C17.6909 9.53061 16.3 8.30612 14.5 8.30612C12.7818 8.30612 11.3091 9.53061 11.3091 11.0816V16.9592C11.3091 17.2857 10.9818 17.6122 10.6545 17.6122C10.3273 17.6122 10 17.2857 10 16.9592V11.0816C10 8.79592 12.0455 7 14.5 7C16.9545 7 19 8.79592 19 11.0816V19.898C19 20.7143 18.5909 21.5306 18.0182 22.102C17.3636 22.6735 16.5455 23 15.6455 23Z",
    fill: "black"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "#E8EEF1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8083_35794"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/attach.0157719b7fd1ec7e2a656e2b734ee860.svg";
export { ForwardRef as ReactComponent };